import api from "../../api";
import type { HistoryApiItem } from "../../../@types/portalAluno";
import { mapHistoryResponse } from "../../../utils/portalAluno/mappers/historyMapper";

export const getHistory = async () => {
  const response = await api.get<HistoryApiItem[]>("mobile/historico");

  return mapHistoryResponse(response.data);
};
